<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.form.declaracoesComparecimento.concat(data.model.declaracoesComparecimento)"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(dataHora)="{index, item}">
                <div v-if="item.centroCusto">
                    <rkm-icon
                        :id="`declaracao-comparecimento-${index}`"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`declaracao-comparecimento-${index}`"
                        triggers="hover"
                    >
                        <div>{{item.centroCusto.setor.nome}}</div>
                        <div><rkm-icon icon="user" /> {{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}</div>
                        <div><rkm-icon :icon="['far', 'clock']" /> {{item.dataHora}}</div>
                    </rkm-popover>

                    {{item.dataHora}}
                </div>
            </template>

            <template v-slot:cell(turno)="{item}">
                {{item.turno ? item.turno.nome : 'Horário personalizado'}}
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    :disabled="!!item.id"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.id"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {class: 'col-min', key: 'dataHora', label: 'Data / Hora', sortable: true},
            {key: 'turno', label: 'Turno', sortable: true},
            {key: 'entrada', label: 'Hora da entrada', sortable: true},
            {key: 'saida', label: 'Hora da saída', sortable: true},
            {key: 'nomeAcompanhante', label: 'Nome do acompanhante', sortable: true},
            {key: 'motivoComparecimento', label: 'Motivo do comparecimento', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente excluir a declaração de comparecimento?', async () => {
                this.data.model.declaracoesComparecimento.splice(this.data.model.declaracoesComparecimento.indexOf(item), 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>